import React from 'react';

import { Button as SemanticButton, ButtonProps } from 'semantic-ui-react';
import styled from 'styled-components';

type ButtonCustomProps = {
  light?: boolean;
};

const CustomButton = styled(SemanticButton)`
  background-color: ${props =>
    props.light ? '#ffffff' : props.theme.main.color} !important;
  border: 1px solid ${props => props.theme.main.color} !important;
  color: ${props => (props.light ? props.theme.main.color : '#ffffff')} !important;
`;

const Button = (props: ButtonProps & ButtonCustomProps) => {
  return (
    <>
      {props.color ? (
        <SemanticButton {...props}>
          {props.text ? props.text : props.children}
        </SemanticButton>
      ) : (
        <CustomButton {...props}>{props.text ? props.text : props.children}</CustomButton>
      )}
    </>
  );
};

export default Button;
